import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { Task } from 'src/app/_models/task';
import { QuestionService } from 'src/app/_services/question.service';
import Swal from 'sweetalert2';
import { AdminService } from '../../../_services/admin.service';
declare var $ : any;
@Component({
  selector: 'app-question-template-show',
  templateUrl: './question-template-show.component.html',
  styleUrls: ['./question-template-show.component.css']
})
export class QuestionTemplateShowComponent implements OnInit {
taskTemplate:Task= undefined

  constructor(
    private adminService:AdminService,
    private route:ActivatedRoute,
    private router:Router,
    private questionService:QuestionService
  ) { }

  ngOnInit(): void {
  this.route.params.subscribe(
    params=>{
      let id=params['server_task_template_id']
      if(id!=0){
        this.questionService.getQuestionTemplateById(id).subscribe(
           {
  next:(data:ResultData)=>{
    this.taskTemplate=data.rs.data
  },error:(err)=>{

  }
 }



        )
      }

    }
  )

  }

  enableDisable(){}
  enableDisableMode(modeId:number){

    this.adminService.addRemoveQuizMode(this.taskTemplate.server_task_template_id,modeId).subscribe(
      xx=>{
        this.taskTemplate=xx
      }
    )
  }

  editTemplate(){
    this.router.navigate(["/admin/taskTemplate/edit"],{queryParams:{questionTemplateId:this.taskTemplate.id}})
  }

  templateIndex(){
    this.router.navigate(["/admin/taskTemplate/index"])
  }

  deleteTemplate(){
    this.adminService.deleteQuestionTemplateById(this.taskTemplate.id).subscribe(
      val=>{
        let msg=""

        if(val=="success"){
          this.router.navigate(["/admin/taskTemplate/index"])
          msg="Yes! Deleted"
        }else{
          msg="Nope!"
        }
        this.showAlert(msg)
      }
    )

  }
  removeSolution(){
    this.adminService.removeSolutionFromTaskTemplate(this.taskTemplate.id).subscribe(
      val=>{
        let msg=""

        if(val!="failed"){
          this.taskTemplate =val
          msg="Yes! Removed"
        }else{
          msg="Nope!"
        }
        this. showAlertRemoveSolution(msg)
      }
    )
  }

confirmRemove(){
  Swal.fire({
    title:'Do Yo Want Remove Solution',
    text: 'Are you sure you want to remove solution from task',
    showCancelButton: true,
    confirmButtonText: 'Yes, Removed it!',
    cancelButtonText: 'No, keep it'
  }).then((result) => {
      if (result.value) {
        this.removeSolution()
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Cancelled',
          'Ok :)',
          'error'
        )
      }
    })
}
  showAlert(msg:String){
    Swal.fire({
    title: '<strong>Delete Task Template</strong>',
    icon: 'info',
    html: ""+msg,
    showCloseButton: true,
    allowOutsideClick: false,
    focusConfirm: true,
    confirmButtonText:'Close',
    confirmButtonAriaLabel: 'Close'
  })
}
showAlertRemoveSolution(msg:String){
  Swal.fire({
  title: '<strong>Remove Solution </strong>',
  icon: 'info',
  html: ""+msg,
  showCloseButton: true,
  allowOutsideClick: false,
  focusConfirm: true,
  confirmButtonText:'Close',
  confirmButtonAriaLabel: 'Close'
})
}

renameTemplate(){
  $("#renameQuestionTemplateModal").modal("show");
}

reloadTemplate(){
  this.questionService.getQuestionTemplateById(this.taskTemplate.server_task_template_id).subscribe(

    {
      next:(data:ResultData)=>{
        this.taskTemplate=data.rs.data
      },error:(err)=>{

      }
     }

  )
}

}
